import React from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { handleLogout } from 'utilities/index';

const LogoutScreen = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();

    React.useEffect(() => {
        handleLogout({
            dispatch,
            navigate,
            location,
        });
    }, [])
    return (
        <Grid
            container
            xs={12}
            height="100dvh"
            display="grid"
            sx={{ placeItems: 'center', backgroundColor: '#f5f5f5' }} // Light background for better visibility
        >
            <Grid item textAlign="center">
                <CircularProgress color="primary" size={40} thickness={4.5} />
                <Typography
                    variant="h5"
                    sx={{ mt: 2, fontWeight: 500, color: 'text.secondary' }}
                >
                    Logging Out...
                </Typography>
            </Grid>
        </Grid>
    )
}

export default LogoutScreen